import { App } from 'vue'
import { Icons } from '@/modules/common/icons'

export default {
	install(Vue: App) {
		Vue.config.globalProperties.Icons = Icons
	},
}
